import { Alert, Button, Dialog, Field, Select } from '@dnx/ui';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../lib/api.js';
import { agentsQuery } from './queries.js';

/** Transferir a conversa para outra pessoa, com nota interna (o paciente não vê). */
export function TransferDialog({ conversationId, currentUserId, onClose, onDone }: {
  conversationId: string; currentUserId: string | null; onClose: () => void; onDone: () => void;
}) {
  const { data: agents } = useQuery(agentsQuery);
  const options = agents?.filter((a) => a.id !== currentUserId) ?? [];
  const [to, setTo] = useState('');
  const [note, setNote] = useState('');
  const transfer = useMutation({
    mutationFn: () => api<void>(`/inbox/conversations/${conversationId}/transfer`, { method: 'POST', body: { toUserId: to, note: note.trim() || undefined } }),
    onSuccess: () => { onDone(); onClose(); },
  });
  return (
    <Dialog open onClose={onClose} title="Transferir conversa" description="A pessoa escolhida passa a responder. A nota fica só para a equipe.">
      <form className="grid gap-4 p-5" onSubmit={(e) => { e.preventDefault(); if (to) transfer.mutate(); }}>
        <Field label="Para quem">
          <Select value={to} onChange={(e) => setTo(e.target.value)} autoFocus>
            <option value="">Escolha…</option>
            {options.map((a) => <option key={a.id} value={a.id}>{a.name}{a.isYou ? ' (você)' : ''}</option>)}
          </Select>
        </Field>
        <Field label="Nota interna (opcional)" hint="Ex.: paciente quer falar sobre o pós-operatório.">
          <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={3} maxLength={500}
            className="w-full resize-none rounded-md border border-border-strong bg-surface px-3 py-2 text-sm text-fg placeholder:text-fg-subtle focus:border-primary" />
        </Field>
        {transfer.error && <Alert tone="danger">{transfer.error.message}</Alert>}
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>Cancelar</Button>
          <Button type="submit" disabled={!to} loading={transfer.isPending}>Transferir</Button>
        </div>
      </form>
    </Dialog>
  );
}
